import { type PublicConfig } from "@vega-core/appConfigs/PublicConfig.type";

import { generateManifest } from "./manifestGenerator";

export type ManifestRequest = {
  portalType: "gp" | "lp";
  companyConfig: PublicConfig;
};

export function createManifestBlobURL(request: ManifestRequest): string {
  const manifest = generateManifest(request.companyConfig, request.portalType);
  const blob = new Blob([JSON.stringify(manifest, null, 2)], {
    type: "application/json",
  });

  return URL.createObjectURL(blob);
}

export function updateManifestLink(manifestURL: string): void {
  const existingLink = document.querySelector('link[rel="manifest"]');

  if (existingLink) {
    existingLink.remove();
  }

  const link = document.createElement("link");
  link.rel = "manifest";
  link.href = manifestURL;
  document.head.appendChild(link);
}

export function updateFavicon(iconPath: string): void {
  const existingFavicons = document.querySelectorAll('link[rel="icon"]');
  existingFavicons.forEach((link) => link.remove());

  const link = document.createElement("link");
  link.rel = "icon";
  link.href = iconPath;
  document.head.appendChild(link);
}

export function updateAppleTouchIcon(iconPath: string): void {
  const existingAppleTouch = document.querySelectorAll(
    'link[rel="apple-touch-icon"]',
  );
  existingAppleTouch.forEach((link) => link.remove());

  const link = document.createElement("link");
  link.rel = "apple-touch-icon";
  link.href = iconPath;
  document.head.appendChild(link);
}

export function updateIOSSharingMeta(config: PublicConfig): void {
  const existingMeta = document.querySelectorAll(
    'meta[property="og:image"], meta[name="twitter:image"]',
  );
  existingMeta.forEach((meta) => meta.remove());

  if (config.pwa?.icons.appleTouch) {
    const ogImage = document.createElement("meta");
    ogImage.setAttribute("property", "og:image");
    ogImage.setAttribute("content", config.pwa.icons.appleTouch);
    document.head.appendChild(ogImage);

    const twitterImage = document.createElement("meta");
    twitterImage.setAttribute("name", "twitter:image");
    twitterImage.setAttribute("content", config.pwa.icons.appleTouch);
    document.head.appendChild(twitterImage);
  }
}

export function updateAllIcons(config: PublicConfig) {
  if (config.theme.favicon) {
    updateFavicon(config.theme.favicon);
  }

  if (config.pwa?.icons.appleTouch) {
    updateAppleTouchIcon(config.pwa.icons.appleTouch);
  }

  updateIOSSharingMeta(config);
}

export function updatePWAIconsOnly(config: PublicConfig) {
  if (config.pwa?.icons.appleTouch) {
    updateAppleTouchIcon(config.pwa.icons.appleTouch);
  }

  updateIOSSharingMeta(config);
}
